import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4 w-full grid grid-cols-3 border-b dark:border-gray-900 text-base font-semibold" }
const _hoisted_2 = { class: "justify-self-end" }
const _hoisted_3 = { class: "justify-self-end" }
const _hoisted_4 = { class: "p-4 -mt-2" }



import { FullPool } from '@/services/balancer/subgraph/types';
import useWeb3 from '@/services/web3/useWeb3';

import useBreakpoints from '@/composables/useBreakpoints';

import AssetRow from './components/AssetRow';
import { bnum } from '@/lib/utils';
import { POOLS } from '@/constants/pools';

/**
 * TYPES
 */
type Props = {
  pool: FullPool;
  loading: boolean;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    loading: { type: Boolean, required: true, default: false }
  } as unknown as undefined,
  setup(__props: {
  pool: FullPool;
  loading: boolean;
}) {

const props = __props


/**
 * COMPOSABLES
 */
const { upToLargeBreakpoint } = useBreakpoints();
const { explorerLinks } = useWeb3();

/**
 * METHODS
 */
function getUnderlyingTokens(address: string) {
  let linearPools = props.pool.onchain.linearPools;
  let addr = address;

  if (props.pool.isMetaBoosted && props.pool.onchain.metaLinearPools) {
    linearPools = props.pool.onchain.metaLinearPools;
    Object.keys(POOLS.MetaStableBoostedTokens).map(key => {
      if (
        POOLS.MetaStableBoostedTokens[key][0].toLowerCase() ===
        address.toLowerCase()
      ) {
        addr = key;
      }
    });
  }

  console.log('!!! getUnderlyingTokens0', linearPools, address, addr);

  if (linearPools == null) {
    return [];
  }

  const mainTokenAddress = linearPools[addr].mainToken.address;

  const ret =
    linearPools != null
      ? [
          linearPools[addr].mainToken,
          {
            ...linearPools[addr].wrappedToken,
            mainTokenAddress
          }
        ]
      : [];

  console.log('!!! getUnderlyingTokens1', ret);

  return ret;
}

function getTokenShare(address: string) {
  const linearPools = props.pool.onchain.linearPools;

  if (linearPools == null) {
    return null;
  }

  const token = props.pool.onchain.tokens[address];
  if (
    !token ||
    !token.balance ||
    !linearPools[address] ||
    !linearPools[address].totalSupply
  ) {
    return null;
  }

  const ret = bnum(token.balance)
    .div(linearPools[address].totalSupply)
    .toString();

  return ret;
}

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalBreakdown = _resolveComponent("BalBreakdown")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    class: "overflow-x-auto whitespace-nowrap",
    square: _unref(upToLargeBreakpoint),
    noBorder: _unref(upToLargeBreakpoint),
    noPad: ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('token')), 1),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('balance')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('value')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.pool.tokenAddresses, (address) => {
          return (_openBlock(), _createElementBlock("div", {
            key: address,
            class: "py-4"
          }, [
            _createVNode(_component_BalBreakdown, {
              items: getUnderlyingTokens(address),
              class: "w-full",
              offsetClassOverrides: "mt-4 ml-3",
              initVertBarClassOverrides: "h-6 -mt-6",
              size: "lg"
            }, {
              item: _withCtx(({ item: asset }) => [
                _createVNode(_unref(AssetRow), {
                  address: asset.address,
                  "main-token-address": asset.mainTokenAddress,
                  balance: asset.balance,
                  "price-rate": asset.priceRate,
                  share: getTokenShare(address)
                }, null, 8, ["address", "main-token-address", "balance", "price-rate", "share"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_BalLink, {
                  href: _unref(explorerLinks).addressLink(address),
                  external: "",
                  noStyle: "",
                  class: "flex items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BalAsset, {
                      address: address,
                      class: "mr-2"
                    }, null, 8, ["address"]),
                    _createTextVNode(" " + _toDisplayString(__props.pool.onchain.tokens[address].symbol) + " ", 1),
                    _createVNode(_component_BalIcon, {
                      name: "arrow-up-right",
                      size: "sm",
                      class: "ml-2 text-gray-500 hover:text-blue-500 transition-colors"
                    })
                  ]),
                  _: 2
                }, 1032, ["href"])
              ]),
              _: 2
            }, 1032, ["items"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["square", "noBorder"]))
}
}

})